import { FC, useEffect, useState } from 'react';

import { css } from '@emotion/react';

import {
  minimumPasswordValidationMessage,
  mustHaveLetterValidationMessage,
  repeatedCharacterValidationMessage,
} from '../passwordValidation';
import PasswordRequirement from './PasswordRequirement';

const requirementsStyle = css`
  li {
    display: flex;
    flex-direction: row;
  }
`;

export const passwordRequirementTestIds = {
  minimumLengthPassword: 'passwordRequirementMinimumLength',
  hasLetter: 'passwordRequirementValidLetter',
  repeatedCharacter: 'passwordRequirementRepeatedCharacters',
};

type PasswordRequirementsProps = {
  password: string;
  passwordErrors?: string;
};

const PasswordRequirements: FC<PasswordRequirementsProps> = ({
  password,
  passwordErrors,
}) => {
  const [validMinimumPasswordLength, setValidMinimumPasswordLength] =
    useState(false);
  const [validLetterValidation, setValidLetterValidation] = useState(false);
  const [validRepeatedCharacters, setValidRepeatedCharacters] = useState(false);

  useEffect(() => {
    if (password.length < 1) {
      setValidLetterValidation(false);
      setValidMinimumPasswordLength(false);
      setValidRepeatedCharacters(false);
      return;
    }

    setValidLetterValidation(
      !passwordErrors?.includes(mustHaveLetterValidationMessage)
    );
    setValidMinimumPasswordLength(
      !passwordErrors?.includes(minimumPasswordValidationMessage)
    );
    setValidRepeatedCharacters(
      !passwordErrors?.includes(repeatedCharacterValidationMessage)
    );
  }, [
    password,
    passwordErrors,
    setValidLetterValidation,
    setValidRepeatedCharacters,
    setValidMinimumPasswordLength,
  ]);

  const requirements: {
    testId: string;
    requirementIsSatisfied: boolean;
    requirementMessage: string;
  }[] = [
    {
      testId: passwordRequirementTestIds.minimumLengthPassword,
      requirementIsSatisfied: validMinimumPasswordLength,
      requirementMessage: minimumPasswordValidationMessage,
    },
    {
      testId: passwordRequirementTestIds.hasLetter,
      requirementIsSatisfied: validLetterValidation,
      requirementMessage: mustHaveLetterValidationMessage,
    },
    {
      testId: passwordRequirementTestIds.repeatedCharacter,
      requirementIsSatisfied: validRepeatedCharacters,
      requirementMessage: repeatedCharacterValidationMessage,
    },
  ];

  return (
    <div css={requirementsStyle}>
      <ul>
        {requirements.map(
          ({ requirementIsSatisfied, requirementMessage, testId }, i) => (
            <li key={i}>
              <PasswordRequirement
                testId={testId}
                requirementIsSatisfied={requirementIsSatisfied}
              >
                {requirementMessage}
              </PasswordRequirement>
            </li>
          )
        )}
      </ul>
    </div>
  );
};

export default PasswordRequirements;
